import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { HiMenuAlt3, HiX } from "react-icons/hi"; // Icons for menu toggle
//import JCSGR from "../Assets/JCS1.jpg";
import JCSGL from "../Assets/JCSg.jpg";

const Fixed = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false); // State for mobile menu
  const navigate = useNavigate();

  // Function to toggle the menu visibility on mobile
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Helper function to check if the current route matches the link
  const getLinkClass = (isActive) => {
    return isActive
      ? "text-xl font-semibold cursor-pointer underline decoration-4 decoration-blue-500"
      : "text-xl font-semibold cursor-pointer hover:underline hover:decoration-4 hover:decoration-blue-500";
  };

  return (
    <header className="fixed top-0 left-0 w-full z-50 bg-white shadow-md">
      <div className="flex justify-between items-center px-4 md:px-10">
        {/* Left - Logo */}
        <div className="flex items-center">
          <img
            className="w-[70px] md:w-[80px] h-[70px] md:h-[80px] rounded-lg cursor-pointer"
            src={JCSGL}
            alt="Logo"
            onClick={() => navigate("/")}
          />
        </div>

        {/* Menu Toggle Button for Mobile */}
        <button
          className="md:hidden text-3xl focus:outline-none"
          onClick={toggleMenu}
        >
          {isMenuOpen ? <HiX /> : <HiMenuAlt3 />}
        </button>

        {/* Navigation Links */}
        <div
          className={`flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-12 items-center absolute md:static top-16 md:top-auto left-0 w-full md:w-auto bg-white md:bg-transparent shadow-md md:shadow-none rounded-lg md:rounded-none px-4 md:px-0 py-4 md:py-0 z-40 transition-all duration-300 ${
            isMenuOpen ? "block" : "hidden md:flex"
          }`}
        >
          <NavLink
            to="/"
            className={({ isActive }) => getLinkClass(isActive)}
          >
            Home
          </NavLink>
          <NavLink
            to="/shop-by-catagories"
            className={({ isActive }) => getLinkClass(isActive)}
          >
            Services
          </NavLink>
          <NavLink
            to="/about-us"
            className={({ isActive }) => getLinkClass(isActive)}
          >
            About Us
          </NavLink>
          <NavLink
            to="/contact-us"
            className={({ isActive }) => getLinkClass(isActive)}
          >
            Contact Us
          </NavLink>
        </div>
      </div>
    </header>
  );
};

export default Fixed;
